// src/hooks/queries/useUsuarios.ts
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface Usuario {
  id: string;
  nombre: string;
  apellido?: string;
  email?: string;
  activo: boolean;
}

export function useUsuarios() {
  return useQuery<Usuario[]>({
    queryKey: ['usuarios'],
    queryFn: async () => {
      // Obtener usuarios del endpoint de usuarios o usar el de clientes como fallback
      try {
        return await api.get<Usuario[]>('/usuarios');
      } catch {
        // Si no existe endpoint, retornar array vacío
        return [];
      }
    },
  });
}

export function useUsuario(id: string) {
  return useQuery<Usuario>({
    queryKey: ['usuarios', id],
    queryFn: () => api.get<Usuario>(`/usuarios/${id}`),
    enabled: !!id,
  });
}
